"use client";

import React from "react";
import { TicketAssigneeCard } from "./TicketAssigneeCard";
import type { AssigneeAggregate } from "./types";

interface TicketAssigneesListProps {
  aggregates: AssigneeAggregate[];
  isLoading: boolean;
}

/**
 * "Assigned to" sub-tab content: renders one `TicketAssigneeCard` per
 * unique assignee on the ticket's tasks.
 */
export function TicketAssigneesList({
  aggregates,
  isLoading,
}: TicketAssigneesListProps) {
  if (isLoading) {
    return <p className="text-sm text-gray-500 py-6">Loading…</p>;
  }

  if (aggregates.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-gray-200 dark:border-gray-700 bg-card-50 p-6 text-center text-sm text-gray-600 dark:text-gray-400">
        No assignees on ticket tasks yet. Assign people on individual tasks, or create
        tasks with assignees.
      </div>
    );
  }

  return (
    <>
      {aggregates.map((aggregate) => (
        <TicketAssigneeCard key={aggregate.userId} aggregate={aggregate} />
      ))}
    </>
  );
}
